import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { gameSectionStore } from "../stores/gamesSection";
import { gameStore } from "../stores/games";
import { blackListWithdrawalsStore } from "../stores/blackListWithdrawals";
import {
	whiteListPlayersWithdrawalsEditModalStore,
} from "../stores/whiteListPlayersWithdrawalsEditModal";
import { whiteListPlayersWithdrawalStore } from "../stores/whiteListPlayersWithdrawals";
import Select from "@cloudscape-design/components/select";
/* ------- */

class WhiteListPlayersWithdrawalsEditModal extends React.Component {
	componentDidUpdate(prevProps) {
		if (!prevProps.whiteListPlayersWithdrawalsEditModal.show && this.props.whiteListPlayersWithdrawalsEditModal.show) {
			this.resetFormFields();
		}
	}

	resetFormFields = () => {
		this.props.setWhiteListPlayersWithdrawalsEditModal({
			...this.props.whiteListPlayersWithdrawalsEditModal,
			wallet: '',
			loaded: true
		});
	};


	editWhiteListWithdrawal() {
		const data = {
			id: this.props.whiteListPlayersWithdrawalsEditModal.id,
			uid: this.props.whiteListPlayersWithdrawalsEditModal.uid,
			description: this.props.whiteListPlayersWithdrawalsEditModal.description,
			brand: this.props.whiteListPlayersWithdrawalsEditModal.brand.value
		}
		this.props.Interface.request("set", {
			class: "data",
			module: "whistListPlayersWithdrawal",
			method: "edit"
		}, { ...data }).then((result) => {
			this.props.Interface.addNoty("Success", "Edit white list was success");
			this.props.setWhiteListPlayersWithdrawalsEditModal({ ...this.props.whiteListPlayersWithdrawalsEditModal, show: false});
			this.props.Interface.loadWhiteListPlayersWithdrawals();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setWhiteListPlayersWithdrawals({ ...this.props.whiteListPlayersWithdrawals, loaded: true, error });
		})
	}


	render() {
		return (
			<>
				<Modal
					visible={this.props.whiteListPlayersWithdrawalsEditModal.show}
					onDismiss={() => {
						this.props.setWhiteListPlayersWithdrawalsEditModal({ ...this.props.whiteListPlayersWithdrawalsEditModal, show: false });
					}}
					header="Edit wallet to black list"
					children={
						<>
							<SpaceBetween direction="vertical" size="m">
								<Input
									autoFocus="true"
									name="Name"
									autoComplete="off"
									inputMode="text"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="Uid"
									value={this.props.whiteListPlayersWithdrawalsEditModal.uid}
									onChange={(input) => {
										this.props.setWhiteListPlayersWithdrawalsEditModal({ ...this.props.whiteListPlayersWithdrawalsEditModal, uid: input.detail.value });
									}}
								/>
								<Select
									filteringType="auto"
									placeholder="Select brand"
									selectedOption={this.props.whiteListPlayersWithdrawalsEditModal.brand}
									onChange={(option) => {
										this.props.setWhiteListPlayersWithdrawalsEditModal({ ...this.props.whiteListPlayersWithdrawalsEditModal, brand: option.detail.selectedOption });
									}
									}
									options={this.props.whiteListPlayersWithdrawalsEditModal.currentOption.brand}
								/>
								<Input
									autoFocus="true"
									name="Description"
									autoComplete="off"
									inputMode="text"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="Description"
									value={this.props.whiteListPlayersWithdrawalsEditModal.description}
									onChange={(input) => {
										this.props.setWhiteListPlayersWithdrawalsEditModal({ ...this.props.whiteListPlayersWithdrawalsEditModal, description: input.detail.value });
									}}
								/>
							</SpaceBetween>
						</>
					}
					footer={
						<>
							<Box
								float="right"
								children={
									<>
										<Box
											variant="span"
											margin={{ right: "s" }}
											children={
												<Button
													variant="normal"
													onClick={() => {
														this.props.setWhiteListPlayersWithdrawalsEditModal({ ...this.props.whiteListPlayersWithdrawalsEditModal, show: false });
													}}
													children="Close"
												/>
											}
										/>
										<Box
											variant="span"
											children={
												<Button
													disabled={this.props.whiteListPlayersWithdrawalsEditModal.wallet === ""}
													variant="primary"
													onClick={() => {
														this.editWhiteListWithdrawal();
													}}
													children="Ok"
												/>
											}
										/>
									</>
								}
							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const whiteListPlayersWithdrawalsEditModal = useRecoilValue(whiteListPlayersWithdrawalsEditModalStore);
		const setWhiteListPlayersWithdrawalsEditModal = useSetRecoilState(whiteListPlayersWithdrawalsEditModalStore);

		const whiteListPlayersWithdrawals = useRecoilValue(whiteListPlayersWithdrawalStore);
		const setWhiteListPlayersWithdrawals = useSetRecoilState(whiteListPlayersWithdrawalStore);

		const config = useRecoilValue(configStore);
		return <Component {...props}  whiteListPlayersWithdrawalsEditModal={whiteListPlayersWithdrawalsEditModal} setWhiteListPlayersWithdrawalsEditModal={setWhiteListPlayersWithdrawalsEditModal} whiteListPlayersWithdrawals={whiteListPlayersWithdrawals} setWhiteListPlayersWithdrawals={setWhiteListPlayersWithdrawals} config={config} />;
	};
}

export default withRecoil(WhiteListPlayersWithdrawalsEditModal);
